export default __webpack_public_path__ + "static/media/ApproveImage.e1091f90.svg";